
import { useEffect, useMemo, useState } from "react";
import { Play, X, ArrowUpRight } from "lucide-react";

const PROJECTS = ["THE SQUARE", "THE PARK", "THE SWISS"];

const SECTIONS = {
    "THE SQUARE": ["THE SQUARE", "OFFICE VISIT"],
    "THE PARK": ["PARK VIEW"],
    "THE SWISS": [
        "GRAND REVEAL EVENT",
        "OFFICE VISIT",
        "SITE VISIT",
        "PARTNERSHIP CONTRACT",
    ],
};

const ACCENTS = {
    "THE SWISS": {
        text: "text-white",
        border: "border-[#002D6A]",
        bg: "bg-[#002D6A]",
        dot: "bg-[#002D6A]",
    },

    "THE PARK": {
        text: "text-white",
        border: "border-[#08362E]",
        bg: "bg-[#08362E]",
        dot: "bg-[#08362E]",
    },

    "THE SQUARE": {
        text: "text-white",
        border: "border-[#B2A367]",
        bg: "bg-[#B2A367]",
        dot: "bg-[#B2A367]",
    },
};

const NEUTRAL_ACCENT = {
    text: "text-[#666666]",
    border: "border-[#BDBDBD]",
    bg: "bg-black/5",
    dot: "bg-[#777777]",
};

/* =====================================================
    HOVER ACCENTS FOR FILTER BUTTONS
    Keys must match the exact strings used in PROJECTS.
====================================================== */

const HOVER_ACCENT = {
    "THE SWISS": "hover:bg-[#002D6A] hover:text-white",
    "THE PARK": "hover:bg-[#08362E] hover:text-white",
    "THE SQUARE": "hover:bg-[#B2A367] hover:text-white",
};

const ITEMS = [
    {
        id: 1,
        project: "THE SWISS",
        section: "GRAND REVEAL EVENT",
        type: "image",
        src: "/GalleryPhotos/Downtown/GrandRevealEvent/revealevent1.jpg",
        // caption: "Studio pass, roll 3",
    },
    {
        id: 2,
        project: "THE SWISS",
        section: "GRAND REVEAL EVENT",
        type: "image",
        src: "/GalleryPhotos/Downtown/GrandRevealEvent/revealevent2.jpg",
        // caption: "Behind the rig",
    },
    {
        id: 3,
        project: "THE SWISS",
        section: "GRAND REVEAL EVENT",
        type: "image",
        src: "/GalleryPhotos/Downtown/GrandRevealEvent/revealevent3.jpg",
        // caption: "Contact sheet 04",
    },
    {
        id: 4,
        project: "THE SWISS",
        section: "GRAND REVEAL EVENT",
        type: "image",
        src: "/GalleryPhotos/Downtown/GrandRevealEvent/revealevent4.jpg",
        // caption: "Final selects",
    },
    {
        id: 5,
        project: "THE SWISS",
        section: "GRAND REVEAL EVENT",
        type: "image",
        src: "/GalleryPhotos/Downtown/GrandRevealEvent/revealevent5.jpg",
        // caption: "Final selects",
    },
    {
        id: 6,
        project: "THE SWISS",
        section: "GRAND REVEAL EVENT",
        type: "image",
        src: "/GalleryPhotos/Downtown/GrandRevealEvent/revealevent6.jpg",
        // caption: "Final selects",
    },
    {
        id: 7,
        project: "THE SWISS",
        section: "GRAND REVEAL EVENT",
        type: "image",
        src: "/GalleryPhotos/Downtown/GrandRevealEvent/revealevent7.jpg",
        // caption: "Final selects", 
    },
    {
        id: 8,
        project: "THE SWISS",
        section: "GRAND REVEAL EVENT",
        type: "image",
        src: "/GalleryPhotos/Downtown/GrandRevealEvent/revealevent8.jpg",
        // caption: "Final selects",
    },
    {
        id: 9,
        project: "THE SWISS",
        section: "GRAND REVEAL EVENT",
        type: "image",
        src: "/GalleryPhotos/Downtown/GrandRevealEvent/revealevent9.jpg",
        // caption: "Final selects",
    },
    // {
    //     id: 10,
    //     project: "THE SWISS",
    //     section: "GRAND REVEAL EVENT",
    //     type: "video",
    //     src: "/GalleryPhotos/Downtown/GrandRevealEvent/revealevent10.mp4",
    //     poster: "/GalleryPhotos/Downtown/GrandRevealEvent/revealevent9.jpg",
    //     // caption: "Grand Reveal Event",
    // },

    {
        id: 11,
        project: "THE SWISS",
        section: "OFFICE VISIT",
        type: "image",
        src: "/GalleryPhotos/Downtown/OfficeVisit/officevisit1.jpg",
        // caption: "Final selects",
    },
    {
        id: 12,
        project: "THE SWISS",
        section: "OFFICE VISIT",
        type: "image",
        src: "/GalleryPhotos/Downtown/OfficeVisit/officevisit2.jpg",
        // caption: "Final selects",
    },
    {
        id: 13,
        project: "THE SWISS",
        section: "OFFICE VISIT",
        type: "image",
        src: "/GalleryPhotos/Downtown/OfficeVisit/officevisit3.jpg",
        // caption: "Final selects",
    },
    {
        id: 14,
        project: "THE SWISS",
        section: "OFFICE VISIT",
        type: "image",
        src: "/GalleryPhotos/Downtown/OfficeVisit/officevisit4.jpg",
        // caption: "Final selects",
    },
    {
        id: 15,
        project: "THE SWISS",
        section: "OFFICE VISIT",
        type: "video",
        src: "/GalleryPhotos/Downtown/OfficeVisit/office.mp4",
        poster: "/GalleryPhotos/Downtown/OfficeVisit/officevisit1.jpg",
        // caption: "Final selects",
    },
    {
        id: 16,
        project: "THE SWISS",
        section: "SITE VISIT",
        type: "image",
        src: "/GalleryPhotos/Downtown/SiteVisit/sitevisit1.jpg",
        // caption: "Final selects",
    },
    {
        id: 17,
        project: "THE SWISS",
        section: "SITE VISIT",
        type: "image",
        src: "/GalleryPhotos/Downtown/SiteVisit/sitevisit2.jpg",
        // caption: "Final selects",
    },
    {
        id: 18,
        project: "THE SWISS",
        section: "SITE VISIT",
        type: "image",
        src: "/GalleryPhotos/Downtown/SiteVisit/sitevisit3.jpg",
        // caption: "Final selects",
    },
    {
        id: 19,
        project: "THE SWISS",
        section: "SITE VISIT",
        type: "image",
        src: "/GalleryPhotos/Downtown/SiteVisit/sitevisit4.jpg",
        // caption: "Final selects",
    },
    {
        id: 20,
        project: "THE SWISS",
        section: "SITE VISIT",
        type: "video",
        src: "/GalleryPhotos/Downtown/SiteVisit/sitevisit5.mp4",
        poster: "/GalleryPhotos/Downtown/SiteVisit/sitevisit4.jpg",
        // caption: "Final selects",
    },

    {
        id: 21,
        project: "THE SWISS",
        section: "PARTNERSHIP CONTRACT",
        type: "image",
        src: "/GalleryPhotos/Downtown/PartnershipContract/contract1.jpeg",
        // caption: "Final selects",
    },
    {
        id: 22,
        project: "THE SWISS",
        section: "PARTNERSHIP CONTRACT",
        type: "image",
        src: "/GalleryPhotos/Downtown/PartnershipContract/contract2.jpg",
        // caption: "Final selects",
    },
    {
        id: 23,
        project: "THE SWISS",
        section: "PARTNERSHIP CONTRACT",
        type: "image",
        src: "/GalleryPhotos/Downtown/PartnershipContract/contract3.jpg",
        // caption: "Final selects",
    },
    {
        id: 24,
        project: "THE SWISS",
        section: "PARTNERSHIP CONTRACT",
        type: "image",
        src: "/GalleryPhotos/Downtown/PartnershipContract/contract4.jpg",
        // caption: "Final selects",
    },
    {
        id: 25,
        project: "THE SWISS",
        section: "PARTNERSHIP CONTRACT",
        type: "image",
        src: "/GalleryPhotos/Downtown/PartnershipContract/contract5.jpeg",
        // caption: "Final selects",
    },
    {
        id: 26,
        project: "THE SWISS",
        section: "PARTNERSHIP CONTRACT",
        type: "image",
        src: "/GalleryPhotos/Downtown/PartnershipContract/contract6.jpeg",
        // caption: "Final selects",
    },
    {
        id: 27,
        project: "THE SWISS",
        section: "PARTNERSHIP CONTRACT",
        type: "image",
        src: "/GalleryPhotos/Downtown/PartnershipContract/contract7.jpeg",
        // caption: "Final selects",
    },
    {
        id: 28,
        project: "THE SWISS",
        section: "PARTNERSHIP CONTRACT",
        type: "image",
        src: "/GalleryPhotos/Downtown/PartnershipContract/contract8.jpeg",
        // caption: "Final selects",
    },
    {
        id: 29,
        project: "THE SWISS",
        section: "PARTNERSHIP CONTRACT",
        type: "image",
        src: "/GalleryPhotos/Downtown/PartnershipContract/contract9.jpeg",
        // caption: "Final selects",
    },
    {
        id: 30,
        project: "THE PARK",
        section: "PARK VIEW",
        type: "image",
        src: "/GalleryPhotos/Park/parkview1.jpg",
        // caption: "Opening sequence",
    },
    {
        id: 31,
        project: "THE PARK",
        section: "PARK VIEW",
        type: "image",
        src: "/GalleryPhotos/Park/parkview2.jpg",
        // caption: "Opening sequence",
    },
    {
        id: 32,
        project: "THE PARK",
        section: "PARK VIEW",
        type: "image",
        src: "/GalleryPhotos/Park/parkview3.jpg",
        // caption: "Opening sequence",
    },
    {
        id: 33,
        project: "THE PARK",
        section: "PARK VIEW",
        type: "image",
        src: "/GalleryPhotos/Park/parkview4.jpg",
        // caption: "Opening sequence",
    },
    {
        id: 34,
        project: "THE PARK",
        section: "PARK VIEW",
        type: "image",
        src: "/GalleryPhotos/Park/parkview5.jpg",
        // caption: "Opening sequence",
    },
    {
        id: 35,
        project: "THE PARK",
        section: "PARK VIEW",
        type: "image",
        src: "/GalleryPhotos/Park/parkview6.jpg",
        // caption: "Opening sequence",
    },
    {
        id: 36,
        project: "THE PARK",
        section: "PARK VIEW",
        type: "image",
        src: "/GalleryPhotos/Park/parkview7.jpg",
        // caption: "Opening sequence",
    },

    {
        id: 37,
        project: "THE SQUARE",
        section: "THE SQUARE",
        type: "video",
        src: "/GalleryPhotos/Square/Square/square7.mp4",
        poster: "/GalleryPhotos/Latest/square1.png",
        // caption: "Set still, scene 1",
    },
    // {
    //     id: 38,
    //     project: "THE SQUARE",
    //     section: "THE SQUARE",
    //     type: "image",
    //     src: "/GalleryPhotos/Square/Square/square2.png",
    //     // caption: "Opening sequence",
    // },
    {
        id: 39,
        project: "THE SQUARE",
        section: "THE SQUARE",
        type: "image",
        src: "/GalleryPhotos/Square/Square/square3.png",
        // caption: "Opening sequence",
    },
    {
        id: 40,
        project: "THE SQUARE",
        section: "THE SQUARE",
        type: "image",
        src: "/GalleryPhotos/Square/Square/square4.png",
        // caption: "Opening sequence",
    },
    {
        id: 41,
        project: "THE SQUARE",
        section: "THE SQUARE",
        type: "image",
        src: "/GalleryPhotos/Square/Square/square5.png",
        // caption: "Opening sequence",
    },
    {
        id: 42,
        project: "THE SQUARE",
        section: "THE SQUARE",
        type: "image",
        src: "/GalleryPhotos/Square/Square/square6.png",
        // caption: "Opening sequence",
    },
    // {
    //     id: 43,
    //     project: "THE SQUARE",
    //     section: "THE SQUARE",
    //     type: "image",
    //     src: "/GalleryPhotos/Square/Square/square1.png",
    //     // caption: "Opening sequence",
    // },
    {
        id: 44,
        project: "THE SQUARE",
        section: "OFFICE VISIT",
        type: "image",
        src: "/GalleryPhotos/Square/OfficeVisit/1.jpeg",
        // caption: "Opening sequence",
    },
    {
        id: 45,
        project: "THE SQUARE",
        section: "OFFICE VISIT",
        type: "image",
        src: "/GalleryPhotos/Square/OfficeVisit/2.jpeg",
        // caption: "Opening sequence",
    },
    {
        id: 46,
        project: "THE SQUARE",
        section: "OFFICE VISIT",
        type: "image",
        src: "/GalleryPhotos/Square/OfficeVisit/3.jpeg",
        // caption: "Opening sequence",
    },
    {
        id: 47,
        project: "THE SQUARE",
        section: "OFFICE VISIT",
        type: "image",
        src: "/GalleryPhotos/Square/OfficeVisit/4.jpeg",
        // caption: "Opening sequence",
    },
    {
        id: 48,
        project: "THE SQUARE",
        section: "OFFICE VISIT",
        type: "image",
        src: "/GalleryPhotos/Square/OfficeVisit/5.jpeg",
        // caption: "Opening sequence",
    },
    {
        id: 49,
        project: "THE SQUARE",
        section: "OFFICE VISIT",
        type: "image",
        src: "/GalleryPhotos/Square/OfficeVisit/6.jpeg",
        // caption: "Opening sequence",
    },
    {
        id: 50,
        project: "THE SQUARE",
        section: "OFFICE VISIT",
        type: "image",
        src: "/GalleryPhotos/Square/OfficeVisit/7.jpeg",
        // caption: "Opening sequence",
    },
];

export default function Gallery() {
    const [active, setActive] = useState("All");
    const [activeSection, setActiveSection] = useState("All");
    const [lightbox, setLightbox] = useState(null);

    const handleProjectChange = (name) => {
        setActive(name);
        setActiveSection("All");
    };

    const availableSections =
        active === "All" ? [] : SECTIONS[active] || [];

    const filtered = useMemo(() => {
        let result =
            active === "All"
                ? ITEMS
                : ITEMS.filter(
                    (item) => item.project === active
                );

        if (active !== "All" && activeSection !== "All") {
            result = result.filter(
                (item) => item.section === activeSection
            );
        }

        return result;
    }, [active, activeSection]);

    /* ================= ESCAPE KEY ================= */

    useEffect(() => {
        const onKey = (e) => {
            if (e.key === "Escape") {
                setLightbox(null);
            }
        };

        window.addEventListener("keydown", onKey);

        return () => {
            window.removeEventListener("keydown", onKey);
        };
    }, []);

    /* ================= LOCK BODY SCROLL ================= */

    useEffect(() => {
        if (lightbox) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [lightbox]);

    const currentAccent =
        active === "All"
            ? NEUTRAL_ACCENT
            : ACCENTS[active] || NEUTRAL_ACCENT;

    return (
        <div className="
            min-h-screen
            w-full
            overflow-x-hidden
            bg-white
            text-[#222]
        ">

            {/* ================= FONTS ================= */}

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=IBM+Plex+Sans:wght@400;500;600&display=swap');

                .font-display {
                    font-family: 'Instrument Serif', serif;
                }

                .font-body {
                    font-family: 'IBM Plex Sans', sans-serif;
                }

                .hide-scrollbar {
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                }

                .hide-scrollbar::-webkit-scrollbar {
                    display: none;
                }
            `}</style>

            {/* =====================================================
                HEADER
                Background image removed.
                Filter tabs are still here.
            ====================================================== */}

            <header
                className="
                    relative
                    // min-h-[330px]
                    // sm:min-h-[350px]
                    // md:min-h-[380px]
                    // lg:min-h-[400px]

                    flex
                    items-end
                    justify-center

                    overflow-hidden

                    bg-white
                    pb-12
                    sm:pb-10
                    md:pb-14
                    lg:pt-14
                    lg:pb-20
                "
            >

                {/* ================= HEADER CONTENT ================= */}

                <div
                    className="
                        relative
                        z-10
                        w-full
                        max-w-6xl
                        mx-auto
                        px-4
                        sm:px-5
                        md:px-8
                        lg:px-10
                    "
                >

                    {/* =================================================
                        PROJECT FILTERS
                    ================================================== */}

                    <div className="flex justify-center w-full">

                        <div
                            className="
                                flex
                                flex-nowrap
                                sm:flex-wrap
                                justify-start
                                sm:justify-center
                                gap-1.5
                                sm:gap-2
                                p-1.5
                                sm:p-2
                                rounded-2xl
                                sm:rounded-full

                                bg-[#F7F7F5]

                                backdrop-blur-md

                                border
                                border-[#E5E5E5]

                                shadow-sm

                                max-w-full
                                overflow-x-auto
                                hide-scrollbar
                            "
                        >

                            {["All", ...PROJECTS].map((name) => {

                                const accent =
                                    name === "All"
                                        ? NEUTRAL_ACCENT
                                        : ACCENTS[name];

                                const isActive =
                                    active === name;

                                const hoverClasses =
                                    HOVER_ACCENT[name] ||
                                    "hover:text-[#111] hover:bg-white";

                                return (
                                    <button
                                        key={name}
                                        onClick={() =>
                                            handleProjectChange(name)
                                        }
                                        className={`
                                            group
                                            flex
                                            items-center
                                            justify-center
                                            gap-1.5
                                            shrink-0

                                            px-3.5
                                            sm:px-5
                                            md:px-6
                                            lg:px-7

                                            py-2
                                            sm:py-2.5

                                            rounded-full

                                            border

                                            text-[11px]
                                            sm:text-xs
                                            md:text-sm

                                            font-body
                                            whitespace-nowrap

                                            transition-all
                                            duration-300

                                            ${isActive
                                                ? `${accent.text} ${accent.border} ${accent.bg}`
                                                : `border-transparent text-[#66696D] ${hoverClasses}`
                                            }
                                        `}
                                    >

                                        {name}

                                        {name !== "All" && (
                                            <span
                                                className={`
                                                    text-[9px]
                                                    sm:text-[10px]

                                                    ${isActive
                                                        ? accent.text
                                                        : "text-[#999]"
                                                    }
                                                `}
                                            >
                                                {/* {String(
                                                    ITEMS.filter(
                                                        (item) =>
                                                            item.project ===
                                                            name
                                                    ).length
                                                ).padStart(2, "0")} */}
                                            </span>
                                        )}

                                    </button>
                                );
                            })}

                        </div>

                    </div>

                    {/* =================================================
                        SECTION FILTERS
                    ================================================== */}

                    {active !== "All" &&
                        availableSections.length > 0 && (

                            <div className="w-full mt-2.5 sm:mt-3 md:mt-4">

                                <div
                                    className="
                                        w-full
                                        overflow-x-auto
                                        hide-scrollbar
                                        px-1
                                        sm:px-2
                                        md:px-3
                                    "
                                >

                                    <div
                                        className="
                                            flex
                                            w-max
                                            min-w-full
                                            sm:min-w-0
                                            justify-start
                                            sm:justify-center
                                            items-center
                                            gap-1.5
                                            sm:gap-2
                                            md:gap-2.5
                                            mx-auto
                                        "
                                    >

                                        {[
                                            "All",
                                            ...availableSections,
                                        ].map((name) => {

                                            const isActive =
                                                activeSection === name;

                                            const sectionHoverClasses =
                                                HOVER_ACCENT[active] ||
                                                "hover:border-[#CCC] hover:text-[#222]";

                                            return (
                                                <button
                                                    key={name}
                                                    onClick={() =>
                                                        setActiveSection(name)
                                                    }
                                                    className={`
                                                        shrink-0
                                                        whitespace-nowrap
                                                        rounded-full
                                                        border
                                                        font-body
                                                        font-medium

                                                        transition-all
                                                        duration-300

                                                        px-3
                                                        py-1.5
                                                        text-[9px]

                                                        sm:px-3.5
                                                        sm:py-2
                                                        sm:text-[10px]

                                                        md:px-4
                                                        md:py-2
                                                        md:text-[11px]

                                                        lg:px-5
                                                        lg:text-xs

                                                        ${isActive
                                                            ? `${currentAccent.text} ${currentAccent.border} ${currentAccent.bg}`
                                                            : `border-[#E5E5E5] text-[#777] bg-[#FAFAFA] ${sectionHoverClasses}`
                                                        }
                                                    `}
                                                >
                                                    {name}
                                                </button>
                                            );
                                        })}

                                    </div>

                                </div>

                            </div>
                        )}

                    {/* =================================================
                        COLOR GUIDE
                    ================================================== */}

                    <div className="mt-4 sm:mt-5 flex justify-center">

                        <div
                            className="
                                flex
                                flex-wrap
                                justify-center
                                gap-4
                                sm:gap-6
                                md:gap-9
                            "
                        >
                            {/* THE SQUARE */}

                            <div className="flex items-center gap-1.5 sm:gap-2">

                                <span className="
                                    w-1.5
                                    h-1.5
                                    sm:w-2
                                    sm:h-2
                                    rounded-full
                                    bg-[#B2A367]
                                " />

                                <span className="
                                    font-body
                                    text-[9px]
                                    sm:text-[10px]
                                    text-[#777]
                                ">
                                    THE SQUARE
                                </span>

                            </div>

                            {/* THE PARK */}

                            <div className="flex items-center gap-1.5 sm:gap-2">

                                <span className="
                                    w-1.5
                                    h-1.5
                                    sm:w-2
                                    sm:h-2
                                    rounded-full
                                    bg-[#08362E]
                                " />

                                <span className="
                                    font-body
                                    text-[9px]
                                    sm:text-[10px]
                                    text-[#777]
                                ">
                                    THE PARK
                                </span>

                            </div>
                            {/* THE SWISS */}

                            <div className="flex items-center gap-1.5 sm:gap-2">

                                <span className="
                                    w-1.5
                                    h-1.5
                                    sm:w-2
                                    sm:h-2
                                    rounded-full
                                    bg-[#002D6A]
                                " />

                                <span className="
                                    font-body
                                    text-[9px]
                                    sm:text-[10px]
                                    text-[#777]
                                ">
                                    THE SWISS
                                </span>

                            </div>
                        </div>
                    </div>
                </div>

                {/* ================= BOTTOM BORDER ================= */}

                <div
                    className="
                        absolute
                        bottom-0
                        left-0
                        right-0
                        h-px
                        bg-[#E5E5E5]
                    "
                />

            </header>

            {/* =====================================================
                GALLERY
            ====================================================== */}

            <main
                className="
                    w-full
                    max-w-6xl
                    mx-auto

                    px-4
                    sm:px-5
                    md:px-8
                    lg:px-10

                    pt-5
                    sm:pt-6
                    md:pt-8
                    lg:pt-9

                    pb-8
                    sm:pb-10
                    md:pb-12
                "
            >

                {/* ================= GALLERY HEADER ================= */}

                <div
                    className="
                        flex
                        items-center
                        justify-between
                        gap-3
                        mb-4
                        sm:mb-5
                        md:mb-6
                    "
                >

                    <p
                        className="
                            font-body
                            text-[9px]
                            sm:text-[10px]
                            md:text-[11px]

                            uppercase

                            tracking-[0.16em]
                            sm:tracking-[0.2em]

                            text-[#777A7D]
                        "
                    >
                        {active === "All"
                            ? "All Projects"
                            : active}
                    </p>

                    <p
                        className="
                            font-body
                            text-[9px]
                            sm:text-[10px]
                            md:text-[11px]

                            text-[#66696D]

                            whitespace-nowrap
                        "
                    >
                        {String(filtered.length).padStart(2, "0")} Works
                    </p>

                </div>

                {/* =================================================
                    MASONRY GALLERY
                ================================================== */}

                <div
                    className="
                        columns-1
                        sm:columns-2
                        lg:columns-3

                        gap-3
                        sm:gap-4
                        lg:gap-5
                    "
                >

                    {filtered.map((item, idx) => {

                        const accent =
                            ACCENTS[item.project] ||
                            NEUTRAL_ACCENT;

                        return (
                            <button
                                key={item.id}
                                onClick={() =>
                                    setLightbox(item)
                                }
                                className="
                                    group
                                    relative
                                    block
                                    w-full

                                    mb-3
                                    sm:mb-4
                                    lg:mb-5

                                    break-inside-avoid

                                    text-left

                                    focus:outline-none
                                "
                            >

                                <div
                                    className="
                                        relative
                                        overflow-hidden

                                        rounded
                                        sm:rounded-md

                                        bg-white
                                    "
                                >

                                    {/* ================= IMAGE ================= */}

                                    <img
                                        src={
                                            item.type === "video"
                                                ? item.poster
                                                : item.src
                                        }
                                        // alt={item.caption}
                                        alt=""
                                        loading="lazy"
                                        className="
                                            block
                                            w-full
                                            h-auto
                                            object-cover

                                            transition-transform
                                            duration-700

                                            group-hover:scale-[1.04]
                                        "
                                    />

                                    {/* ================= HOVER OVERLAY ================= */}

                                    <div
                                        className="
                                            absolute
                                            inset-0

                                            bg-black/0
                                            group-hover:bg-black/30

                                            transition-all
                                            duration-500
                                        "
                                    />

                                    {/* ================= VIDEO PLAY ================= */}

                                    {item.type === "video" && (

                                        <span
                                            className="
                                                absolute
                                                inset-0

                                                flex
                                                items-center
                                                justify-center
                                            "
                                        >

                                            <span
                                                className="
                                                    w-10
                                                    h-10

                                                    sm:w-11
                                                    sm:h-11

                                                    md:w-12
                                                    md:h-12

                                                    rounded-full

                                                    bg-black/30
                                                    backdrop-blur-sm

                                                    flex
                                                    items-center
                                                    justify-center

                                                    transition-transform
                                                    duration-300

                                                    group-hover:scale-110
                                                "
                                            >

                                                <Play
                                                    size={14}
                                                    className="
                                                        text-white
                                                        ml-0.5
                                                        sm:hidden
                                                    "
                                                    fill="currentColor"
                                                />

                                                <Play
                                                    size={17}
                                                    className="
                                                        hidden
                                                        sm:block
                                                        text-white
                                                        ml-0.5
                                                    "
                                                    fill="currentColor"
                                                />

                                            </span>

                                        </span>
                                    )}

                                    {/* ================= IMAGE INFORMATION ================= */}

                                    <div
                                        className="
                                            absolute
                                            inset-x-0
                                            bottom-0

                                            bg-gradient-to-t
                                            from-black/90
                                            via-black/40
                                            to-transparent

                                            px-3
                                            sm:px-4

                                            pt-10
                                            sm:pt-14

                                            pb-3
                                            sm:pb-4

                                            opacity-0
                                            group-hover:opacity-100

                                            transition-opacity
                                            duration-300
                                        "
                                    >

                                        <p
                                            className={`
                                                font-body

                                                text-[9px]
                                                sm:text-[10px]
                                                md:text-[11px]

                                                tracking-wide

                                                ${accent.text}
                                            `}
                                        >
                                            No.{" "}
                                            {String(idx + 1).padStart(
                                                2,
                                                "0"
                                            )}

                                            {" — "}

                                            {item.project}

                                            {" · "}

                                            {item.section}
                                        </p>
                                        {/* 
                                        <p
                                            className="
                                                font-body

                                                text-[11px]
                                                sm:text-[12px]
                                                md:text-[13px]

                                                text-white/90

                                                mt-0.5
                                                sm:mt-1
                                            "
                                        >
                                            {item.caption}
                                        </p> */}

                                    </div>

                                </div>

                            </button>
                        );
                    })}

                </div>

                {/* ================= EMPTY STATE ================= */}

                {filtered.length === 0 && (

                    <p
                        className="
                            font-body
                            text-[#777]
                            text-sm

                            py-16
                            sm:py-20

                            text-center
                        "
                    >
                        Nothing filed under this project yet.
                    </p>
                )}

            </main>

            {/* =====================================================
                LIGHTBOX
            ====================================================== */}

            {lightbox && (

                <div
                    className="
                        fixed
                        inset-0
                        z-[9999]

                        bg-black/95

                        flex
                        items-center
                        justify-center

                        p-3
                        sm:p-4
                        md:p-8

                        pt-16
                        sm:pt-20
                    "
                    onClick={() =>
                        setLightbox(null)
                    }
                >

                    {/* ================= CLOSE BUTTON ================= */}

                    <button
                        onClick={() =>
                            setLightbox(null)
                        }
                        className="
                            absolute

                            top-3
                            right-3

                            sm:top-5
                            sm:right-5

                            md:top-7
                            md:right-8

                            z-[10000]

                            w-9
                            h-9

                            sm:w-10
                            sm:h-10

                            md:w-11
                            md:h-11

                            rounded-full

                            flex
                            items-center
                            justify-center

                            bg-black/50

                            border
                            border-white/20

                            text-white/80

                            hover:text-white
                            hover:bg-white/10

                            transition-all
                        "
                        aria-label="Close"
                    >

                        <X
                            size={20}
                            className="sm:hidden"
                        />

                        <X
                            size={25}
                            className="hidden sm:block"
                        />

                    </button>

                    {/* ================= LIGHTBOX CONTENT ================= */}

                    <div
                        className="
                            relative
                            z-[10000]

                            w-full
                            max-w-6xl

                            max-h-[calc(100vh-90px)]
                            sm:max-h-[calc(100vh-100px)]

                            flex
                            flex-col
                            items-center
                        "
                        onClick={(e) =>
                            e.stopPropagation()
                        }
                    >

                        {/* ================= IMAGE ================= */}

                        {lightbox.type === "image" ? (

                            <img
                                src={lightbox.src}
                                // alt={lightbox.caption}
                                alt=""
                                className="
                                    max-h-[calc(100vh-170px)]
                                    sm:max-h-[calc(100vh-160px)]
                                    md:max-h-[calc(100vh-150px)]

                                    max-w-full
                                    w-auto

                                    object-contain

                                    rounded
                                    sm:rounded-md

                                    shadow-2xl
                                "
                            />

                        ) : (

                            /* ================= VIDEO ================= */

                            <video
                                src={lightbox.src}
                                controls
                                autoPlay
                                playsInline
                                className="
                                    max-h-[calc(100vh-170px)]
                                    sm:max-h-[calc(100vh-160px)]
                                    md:max-h-[calc(100vh-150px)]

                                    max-w-full
                                    w-full

                                    object-contain

                                    rounded
                                    sm:rounded-md

                                    bg-black

                                    shadow-2xl
                                "
                            />
                        )}

                        {/* ================= LIGHTBOX INFORMATION ================= */}

                        <div
                            className="
                                w-full

                                flex
                                flex-col

                                sm:flex-row
                                sm:items-center
                                sm:justify-between

                                gap-2
                                sm:gap-3

                                mt-3
                                sm:mt-4

                                px-0
                                sm:px-1

                                font-body
                            "
                        >

                            <p
                                className="
                                    text-[10px]
                                    sm:text-[11px]
                                    md:text-[13px]

                                    text-white

                                    leading-5
                                "
                            >
                                {lightbox.project}

                                {" · "}

                                {lightbox.section}

                                {" — "}

                                {/* {lightbox.caption} */}
                            </p>

                            <span
                                className="
                                    flex
                                    items-center
                                    gap-1

                                    text-[9px]
                                    sm:text-[10px]
                                    md:text-[11px]

                                    text-white

                                    whitespace-nowrap
                                "
                            >

                                <ArrowUpRight size={11} />

                                ESC to close

                            </span>

                        </div>

                    </div>

                </div>
            )}

        </div>
    );
}